<ion-grid>
  <ion-row>

    <ion-col>

      <!--div style="margin-top: 10px;">
        <ion-button color="primary" id="bizonylat">
          <ion-icon slot="start" name="add"></ion-icon>
          Új
        </ion-button>
        <ion-button color="secondary" [disabled]="selected.length==0">
          <ion-icon slot="start" name="create"></ion-icon>
          Módosítás
        </ion-button>
        <ion-button color="danger" [disabled]="selected.length==0">
          <ion-icon slot="start" name="trash"></ion-icon>
          Törlés
        </ion-button>
      </div-->
      <!-- ═══════════════════════ Szűrőpanel ═══════════════════════ -->
      <div class="biz-filterwrap">
        <div class="biz-toolbar">
          <div class="biz-search">
            <ion-icon name="search-outline"></ion-icon>
            <input #search id="search" type="text" placeholder="Keresés sorszámra vagy vevőre…"
              [(ngModel)]="filter.search" (ngModelChange)="applyFilters()" />
            <ion-icon *ngIf="filter.search" name="close-circle" class="clear"
              (click)="filter.search=''; applyFilters()"></ion-icon>
          </div>

          <div class="biz-daterange" [title]="'Az időszak a(z) ' + (filter.dateField==='created_at' ? 'kiállítás' : filter.dateField==='teljesites' ? 'teljesítés' : 'fizetési határidő') + ' dátumára szűr'">
            <ion-icon name="calendar-outline"></ion-icon>
            <input type="date" [(ngModel)]="filter.dateFrom" (ngModelChange)="applyFilters()" aria-label="Dátumtól" />
            <span class="dash">–</span>
            <input type="date" [(ngModel)]="filter.dateTo" (ngModelChange)="applyFilters()" aria-label="Dátumig" />
          </div>

          <button type="button" class="biz-filterbtn" [class.active]="showFilters || aktivSzurokSzama()>0"
            (click)="showFilters = !showFilters">
            <ion-icon name="options-outline"></ion-icon>
            <span>Szűrők</span>
            <span class="badge" *ngIf="aktivSzurokSzama()>0">{{ aktivSzurokSzama() }}</span>
            <ion-icon class="chev" [name]="showFilters ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>

          <div class="biz-perpage">
            <label for="per-page">Oldalméret</label>
            <select id="per-page" (change)="onLimitChange($event)">
              <option *ngFor="let option of pageLimitOptions" [value]="option.value"
                [selected]="option.value == currentPageLimit">{{ option.value }}</option>
            </select>
          </div>
        </div>

        <!-- Kibontható részletes szűrők -->
        <div class="biz-filterpanel" *ngIf="showFilters">
          <div class="fp-section">
            <div class="fp-label">Fizetési státusz</div>
            <div class="fp-pills">
              <button type="button" class="pill" [class.on]="filter.status.fizetett" (click)="toggleStatus('fizetett')"><span class="dot green"></span>Fizetett</button>
              <button type="button" class="pill" [class.on]="filter.status.esedekes" (click)="toggleStatus('esedekes')"><span class="dot blue"></span>Esedékes</button>
              <button type="button" class="pill" [class.on]="filter.status.lejart" (click)="toggleStatus('lejart')"><span class="dot red"></span>Lejárt</button>
              <button type="button" class="pill" [class.on]="filter.status.nemfiz" (click)="toggleStatus('nemfiz')"><span class="dot grey"></span>Nem fizetendő</button>
            </div>
          </div>

          <div class="fp-section" *ngIf="tipusValaszthato.length">
            <div class="fp-label">Bizonylat típusa</div>
            <div class="fp-pills">
              <button type="button" class="pill" *ngFor="let t of tipusValaszthato" [class.on]="filter.tipus[t.k]"
                (click)="toggleTipus(t.k)">
                <img [src]="t.icon" width="18" height="18" alt="" /> {{ t.nev }}
              </button>
            </div>
          </div>

          <div class="fp-grid">
            <div class="fp-field">
              <label>Bizonylattömb</label>
              <select [(ngModel)]="filter.tomb" (ngModelChange)="applyFilters()">
                <option value="">Mind</option>
                <option *ngFor="let t of tombLista" [value]="t.id">{{ t.elotag }}</option>
              </select>
            </div>
            <div class="fp-field">
              <label>Család / vevő</label>
              <select [(ngModel)]="filter.csalad" (ngModelChange)="applyFilters()">
                <option value="">Mind</option>
                <option *ngFor="let cs of csaladLista" [value]="cs.id">{{ cs.nev }}</option>
              </select>
            </div>
            <div class="fp-field">
              <label>Fizetési mód</label>
              <select [(ngModel)]="filter.fizmod" (ngModelChange)="applyFilters()">
                <option value="">Mind</option>
                <option *ngFor="let m of fizmodLista" [value]="m">{{ m }}</option>
              </select>
            </div>
            <div class="fp-field">
              <label>Időszak alapja</label>
              <div class="fp-radios">
                <button type="button" class="radio" [class.on]="filter.dateField==='created_at'" (click)="setDateField('created_at')">Kiállítás</button>
                <button type="button" class="radio" [class.on]="filter.dateField==='teljesites'" (click)="setDateField('teljesites')">Teljesítés</button>
                <button type="button" class="radio" [class.on]="filter.dateField==='fiz_hat'" (click)="setDateField('fiz_hat')">Határidő</button>
              </div>
            </div>
          </div>

          <div class="fp-footer">
            <button type="button" class="fp-reset" (click)="resetFilters()" [disabled]="!aktivSzurokSzama()">
              <ion-icon name="close-outline"></ion-icon> Szűrők törlése
            </button>
          </div>
        </div>

        <!-- Statisztika csík -->
        <div class="biz-stats">
          <div class="stat"><span class="k">Találat</span><span class="v">{{ statDb }} db</span></div>
          <div class="stat"><span class="k">Összeg</span><span class="v">{{ statBrutto | currency:'HUF':'':'0.0' }} Ft</span></div>
          <div class="stat kint" *ngIf="statKintlevo>0"><span class="k">Ebből kintlévő</span><span class="v">{{ statKintlevo | currency:'HUF':'':'0.0' }} Ft</span></div>
        </div>
      </div>
      <ng-container>
        <ngx-datatable (select)="onSelect($event)" [limit]="10" #table [footerHeight]="60"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="filteredInvoices" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [selected]="selected"
          [selectionType]="SelectionType.checkbox" [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
            [resizeable]="false">
            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn">
              <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn">
              <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Típus" prop="tipus" [width]="100">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <b class="mobil">Típus</b>
                <img *ngIf="value == '1'" src="assets/icon/icons8-invoice-96.png" width="32px" title="Számla">
                <img *ngIf="value == '2'" src="assets/icon/icons8-proforma-invoice-80.png" width="32px"
                  title="Előleg számla">
                <img *ngIf="value == '3'" src="assets/icon/icons8-message-96.png" width="32px" title="Díjbekérő">
                <img *ngIf="value == '4'" src="assets/icon/icons8-receipt-96.png" width="32px" title="Nyugta">
                <img *ngIf="value == '5'" src="assets/icon/icons8-clipboard-96.png" width="32px" title="Árajánlat">
                <img *ngIf="value == '6'" src="assets/icon/icons8-delivery-96.png" width="32px" title="Szállítólevél">
                <img *ngIf="value == '7'" src="assets/icon/icons8-task-completed-96.png" width="32px"
                  title="Teljesítésigazolás">
                <img *ngIf="value == '8'" src="assets/icon/icons8-shredder-96.png" width="32px" title="Storno számla">
                <img *ngIf="value == '9'" src="assets/icon/icons8-proforma-invoice-80.png" width="32px" title="Módosító számla">
                <!-- Számviteli bizonylat; a támogatási befizetésé a Támogatás fül ikonját kapja. -->
                <img *ngIf="value == '10' && row.tomb_tandij == 1" src="assets/icon/icons8-cash-in-hand-96.png" width="32px"
                  title="Támogatási befizetés – számviteli bizonylat">
                <img *ngIf="value == '10' && row.tomb_tandij != 1" src="assets/icon/icons8-general-ledger-96.png" width="32px"
                  title="Számviteli bizonylat">
                <span>{{row.szamlaszam}}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Státusz" prop="created_at">
            <!--ng-template
    let-column="column"
    ngx-datatable-header-template>
    <img src="assets/icon/icons8-money2-96.png" title="Fizetési státusz" width="32px">
  </ng-template-->
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Státusz</b>
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <img *ngIf="row.status == '1'" src="assets/icon/icons8-today-96.png" width="32px" title="Rendezve">
                <img *ngIf="row.status == '0'" src="assets/icon/icons8-tomorrow-96.png" width="32px" title="Esedékes">
                <img *ngIf="row.status == '-1'" src="assets/icon/icons8-leave-96.png" width="32px" title="Rendezetlen">
                <span *ngIf="row.status == 'nf'" style="color:#888" title="Nem fizetendő">Nem fizetendő</span>
                <span *ngIf="row.status != '1' && row.status != 'nf'">{{row.mennyinap}} nap</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="NAV" prop="navbekuldve" *ngIf="lathatNav">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">NAV</b>
              <img *ngIf="(row.tipus == 1 || row.tipus == 8 || row.tipus == 9) && value==0" src="assets/icon/icons8-data-pending-96.png" width="32px"
                title="Beküldés folyamatban">
              <img *ngIf="(row.tipus == 1 || row.tipus == 8 || row.tipus == 9) && value==1" src="assets/icon/icons8-data-quality-96.png" width="32px"
                title="Beküldve">
              <img *ngIf="row.tipus == 3" src="assets/icon/icons8-filing-cabinet-96.png" width="32px"
                title="Nem NAV adatszolgáltatás">
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Cashbook" prop="cashbookbekuldve" *ngIf="lathatCashbook">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Cashbook</b>
              <img *ngIf="sajatIntezmeny?.cashbook == 1 && (row.tipus == 1 || row.tipus == 8 || row.tipus == 9) && value==0"
                src="assets/icon/icons8-data-pending-96.png" width="32px" title="Beküldés folyamatban">
              <img *ngIf="sajatIntezmeny?.cashbook == 1 && (row.tipus == 1 || row.tipus == 8 || row.tipus == 9) && value==1"
                src="assets/icon/icons8-data-quality-96.png" width="32px" title="Beküldve">
              <img *ngIf="row.tipus == 3" src="assets/icon/icons8-filing-cabinet-96.png" width="32px"
                title="Nem adatszolgáltatás">
              <img *ngIf="row.tipus != 3 && sajatIntezmeny?.cashbook != 1" src="assets/icon/icons8-minus-96.png"
                width="32px" title="Nincs összekötve">
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Vevő" prop="username">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Vevő</b>
              {{ vevoNev(row) || '—' }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Határidő" prop="fiz_hat">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Határidő</b>
              <span *ngIf="value">{{ value | date:'y. MM. dd.'}}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Összeg" prop="osszesen">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Összeg</b>
              {{ value | currency: 'HUF' : '' : '0.0' }} Ft
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>


              <ion-button color="primary" size="small" style="margin-top:0" title="Fizetés bankkártyával"
                *ngIf="fizetesMod.stripe && !fizetesLezarva(row.id)"
                [disabled]="row.status==1 || row.tipus=='8' || row.osszesen <= 0"
                (click)="fizetesMegnyit(row.id, 'stripe')">
                <ion-icon slot="icon-only" name="card"></ion-icon>

              </ion-button>
              <!-- OTP SimplePay – ugyanaz a számla, másik fizetési szolgáltató -->
              <ion-button color="tertiary" size="small" style="margin-top:0" title="Fizetés SimplePay-jel"
                *ngIf="fizetesMod.simple && !fizetesLezarva(row.id)"
                [disabled]="row.status==1 || row.tipus=='8' || row.osszesen <= 0"
                (click)="fizetesMegnyit(row.id, 'simple')">
                <ion-icon slot="icon-only" name="wallet"></ion-icon>
              </ion-button>
              <!-- Nincs aktív fizetőkapu: a gomb elrejtése önmagában néma lenne. -->
              <ion-button color="medium" size="small" style="margin-top:0" [disabled]="true"
                *ngIf="nincsFizetokapu && !fizetesLezarva(row.id)"
                title="Jelenleg nem aktív egy fizetőkapu sem">
                <ion-icon slot="icon-only" name="card-outline"></ion-icon>
              </ion-button>
              <!-- A fizetés megérkezett, a könyvelés még fut – ne induljon újabb fizetés -->
              <ion-button color="warning" size="small" style="margin-top:0" [disabled]="true"
                *ngIf="feldolgozasAlatt(row.id)" title="Fizetés feldolgozása – a számla készül">
                <ion-spinner name="dots" style="width:18px;height:18px"></ion-spinner>
              </ion-button>
              <!-- Kifizetve (online fizetéssel): zöld jel, újra fizetni nem lehet -->
              <ion-button color="success" size="small" style="margin-top:0" [disabled]="true"
                *ngIf="kifizetve(row.id)" title="Kifizetve">
                <ion-icon slot="icon-only" name="checkmark-circle"></ion-icon>
              </ion-button>
              <ion-button color="secondary" size="small" style="margin-top:0"
                [href]="'/api/file/'+sajatIntezmeny.intezmenyId+'/invoice/'+row.id+'.pdf'" target="_blank">
                <ion-icon slot="icon-only" name="eye"></ion-icon>

              </ion-button>
              <ion-button color="tertiary" size="small" style="margin-top:0" title="PDF újragenerálása (aláírással)"
                *ngIf="stornozhat" [disabled]="pdfUjraFut[row.id]" (click)="pdfUjra(row)">
                <ion-icon slot="icon-only" name="refresh"></ion-icon>
              </ion-button>
              <!--ion-button color="tertiary" size="small" style="margin-top:0" title="Főkönyv" [disabled]="1">
                <ion-icon slot="icon-only" name="book"></ion-icon>
              </ion-button-->
              <ion-button [id]="'storno'+row.id" color="danger" size="small" style="margin-top:0"
                *ngIf="row.tipus != '8' && row.storno != '1' && stornozhat" (click)="stornoTarget = row">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
              <ion-alert [trigger]="'storno'+row.id" header="Biztosan stornózzuk?" [buttons]="alertButtons"
                (didDismiss)="stornoSzamla($event)"></ion-alert>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer>
            <ng-template
      let-rowCount="rowCount"
      let-pageSize="pageSize"
      let-selectedCount="selectedCount"
      let-curPage="curPage"
      let-offset="offset"
      ngx-datatable-footer-template
    >
      Látható: {{curPage}} / {{pageSize}}, összesen {{rowCount}} elemből
      
      <app-datatable-pager
        [page]="curPage"
        [visiblePagesCount]="currentVisible"
        [size]="pageSize"
        [count]="rowCount"
        [hidden]="false"
        (change)="table.onFooterPage($event)">
      </app-datatable-pager>
    </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>





<ion-modal class="" style="z-index: 1000" #bizonylatmodal trigger="bizonylat">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új bizonylat</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;text-align: center;">
      <ion-button color="light" (click)="confirm(1)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-invoice-96.png" width="50px">
          <span>Számla<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(2)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-proforma-invoice-80.png" width="50px">
          <span>Előleg számla<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(3)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-message-96.png" width="50px">
          <span>Díjbekérő<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(4)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-receipt-96.png" width="50px">
          <span>Nyugta<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(5)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-clipboard-96.png" width="50px">
          <span>Árajánlat<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(6)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-delivery-96.png" width="50px">
          <span>Szállítólevél<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
      <ion-button color="light" (click)="confirm(7)" style="min-width: 100px;">
        <div class="custom-button-content">
          <img src="assets/icon/icons8-task-completed-96.png" width="50px">
          <span>Teljesítésigazolás<br>
            <select name="nezet" style="visibility: hidden;">
              <option value="0">-</option>
            </select>
          </span>
        </div>
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>




<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új {{bizonylatok[bizonylattipus]}}</ion-title>
        <ion-buttons slot="end">
          <ion-button style="background: white; border-radius: 5px" (click)="confirm(1)" [strong]="true" shape="round"
            color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">

      <ion-segment value="1" color="primary" [scrollable]="true" [(ngModel)]="segment">
        <ion-segment-button value="1" layout="icon-start">
          <ion-label>Ki a címzett?</ion-label>
          <ion-icon name="person"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="2" layout="icon-start">
          <ion-label>Tételek</ion-label>
          <ion-icon name="call"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="4" layout="icon-start">
          <ion-label>Egyéb adatok</ion-label>
          <ion-icon name="log-in"></ion-icon>
        </ion-segment-button>
      </ion-segment>
      <hr>

      <form [formGroup]="form">
        <ion-grid>
          <ion-row *ngIf="segment=='1'">
            <!--table style="width: 100%;">
      <thead>

      </thead>
      <tbody>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
      </tbody>
    </table-->
            <ion-col>
              <ion-input label="Előtag" label-placement="stacked" fill="outline" placeholder="">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Születési előtag" label-placement="stacked" fill="outline" placeholder="">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Anyja leánykori előtag" label-placement="stacked" fill="outline" placeholder="">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Születési hely" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="balloon" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési hely</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Születési hely</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="balloon" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="telepules" formControlName="telepules" itemValueField="id"
                      itemTextField="full_name_irsz" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="false"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <!--ion-input label="Anyanyelv" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
                name="globe" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Anyanyelv</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Anyanyelv</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="globe" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="anyanyelv" itemValueField="id"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-input label="Oktatási azonosító" label-placement="stacked" fill="outline" placeholder=""
                maxlength="11" minlength="11"><ion-icon slot="start" name="business"
                  aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Igazolvány típus" label-placement="stacked" fill="outline" placeholder=""></ion-input-->
              <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Igazolvány típus"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
                <ion-select-option value="apples">Személyi igazolvány</ion-select-option>
                <ion-select-option value="oranges">Ideiglenes személyi igazolvány</ion-select-option>
                <ion-select-option value="bananas">Jogosítvány</ion-select-option>
                <ion-select-option value="bananas">Útlevél</ion-select-option>
                <ion-select-option value="bananas">Tartózkodási / lakcímet igazoló engedély</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col>
              <ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder="">
                <ion-icon slot="start" name="people" aria-hidden="true"></ion-icon>
              </ion-input><br>
              <ion-input label="Születési családi név" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="people" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Anyja családi név" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="people" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Születési idő" label-placement="stacked" fill="outline" placeholder="" type="date"
                max="3000-12-31"><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input><br>

              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  <ion-datetime style="border: 1px solid;" id="datetime" [firstDayOfWeek]="1" presentation="date"
                    [formatOptions]="{
                  date: {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  },
                }"></ion-datetime>
                </ng-template>
              </ion-modal>
              <!--ion-input label="Állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Állampolgárság</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Állampolgárság</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="planet" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="allampolgar1"
                      itemValueField="id" itemTextField="nev" [canSearch]="true" [canClear]="true"
                      closeButtonText="Mégse" [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="true" clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Nem"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="male-female" aria-hidden="true"></ion-icon>
                <ion-select-option value="1">Férfi</ion-select-option>
                <ion-select-option value="2">Nő</ion-select-option>
                <ion-select-option value="3">Egyéb</ion-select-option>
              </ion-select><br>
              <ion-input label="Igazolvány szám" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="id-card" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input label="Utónév" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
                  name="person" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Születési utónév" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="person" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Anyja utónév" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="person" aria-hidden="true"></ion-icon></ion-input><br>
              <!--ion-input label="Születési ország" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="earth" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési ország</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Születési ország</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="globe" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="orszag" formControlName="orszag" itemValueField="id"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <!--ion-input label="Második állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Második állampolgárság</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Második állampolgárság</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="planet" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="allampolgar" formControlName="allampolgar2"
                      itemValueField="id" itemTextField="nev" [canSearch]="true" [canClear]="true"
                      closeButtonText="Mégse" [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="true" clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-input label="TAJ-szám" label-placement="stacked" fill="outline" placeholder=""
                [pattern]="[0-9]"><ion-icon slot="start" name="medical" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Adóazonosító jel" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>



          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <ion-input label="Értesítési telefonszám" label-placement="stacked" fill="outline" placeholder=""
                type="tel"><ion-icon slot="start" name="call" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>
              <ion-input type="email" label="Értesítési e-mail cím" label-placement="stacked" fill="outline"
                placeholder=""><ion-icon slot="start" name="mail" aria-hidden="true"></ion-icon>

                <ion-icon color="danger" slot="icon-only" name="close-circle" aria-hidden="true" slot="end"></ion-icon>

              </ion-input>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <div style="margin-top: 10px;">
                <ion-button color="primary" id="uzenet">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="allomany"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'created_at', dir: 'desc' },
        { prop: 'updated_at', dir: 'desc' },
        { prop: 'priority', dir: 'desc' },
        { prop: 'deadline', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="Típus">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Típus</b>
                      {{ row.viselt_vez }} {{ row.viselt_ker }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Ország">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Ország</b>

                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Irsz." prop="szul_hely">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Irsz.</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Helység" prop="oktazon">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Helység</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Cím" prop="adid">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Cím</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Alapértelmezett" prop="adid">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Alapértelmezett</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Műveletek">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Műveletek</b>
                      <ion-button color="secondary" size="small" style="margin-top:0">
                        <ion-icon slot="icon-only" name="create"></ion-icon>

                      </ion-button>
                      <ion-button color="danger" size="small" style="margin-top:0">
                        <ion-icon slot="icon-only" name="trash"></ion-icon>

                      </ion-button>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>



          <ion-row *ngIf="segment=='3'">
            <ion-col>
              <ion-input label="Munkakör" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
                  name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
            <ion-col>
              <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Jogviszony"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="ribbon" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Munkaviszony - határozott időre</ion-select-option>
                <ion-select-option value="1">Munkaviszony - határozatlan időre</ion-select-option>
                <ion-select-option value="2">Köznevelési foglalkoztatott - határozott időre</ion-select-option>
                <ion-select-option value="3">Köznevelési foglalkoztatott - határozatlan időre</ion-select-option>
                <ion-select-option value="4">Közalkalmazott - határozott időre</ion-select-option>
                <ion-select-option value="5">Közalkalmazott - határozatlan időre</ion-select-option>
                <ion-select-option value="6">Polgári - megbízás</ion-select-option>
                <ion-select-option value="7">Óraadó - megbízás</ion-select-option>
                <ion-select-option value="8">Egyházi szolgálat</ion-select-option>
                <ion-select-option value="9">Egyéni/társas vállalkozó</ion-select-option>
              </ion-select><br>
            </ion-col>
            <ion-col>

              <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Pedagógus fokozat"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Nincs fokozat</ion-select-option>
                <ion-select-option value="1">Gyakornok</ion-select-option>
                <ion-select-option value="2">Pedagógus 1</ion-select-option>
                <ion-select-option value="3">Pedagógus 2</ion-select-option>
                <ion-select-option value="3">Mesterpedagógus</ion-select-option>
                <ion-select-option value="3">Kutatótanár</ion-select-option>
              </ion-select><br>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='3'">
            <ion-col>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;">
                      Vezető beosztás</ion-checkbox>
                  </div>
                </label>
              </div><br>
              <ion-select aria-label="Igazolvány típus" interface="popover" placeholder=""
                label="Foglalkoztatás jellege" label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Teljes munkaidő</ion-select-option>
                <ion-select-option value="1">Részmunkaidő</ion-select-option>
                <ion-select-option value="2">Óraadó</ion-select-option>
              </ion-select><br>
              <ion-input label="Alkalmazás kezdete" label-placement="stacked" fill="outline" placeholder="" type="date"
                max="3000-12-31"><ion-icon slot="start" name="person-circle"
                  aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
            <ion-col>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;">
                      Csökkentett munkaidő</ion-checkbox>
                  </div>
                </label>
              </div><br>

              <ion-input label="Részmunkaidő aránya" label-placement="stacked" fill="outline" placeholder=""
                type="number"><ion-icon slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input>
              <br>
              <ion-input label="Alkalmazás vége" label-placement="stacked" fill="outline" placeholder="" type="date"
                max="3000-12-31"><ion-icon slot="start" name="person-circle"
                  aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
            <ion-col>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;">
                      Utazó gyógypedagógus</ion-checkbox>
                  </div>
                </label>
              </div><br>
              <ion-input label="Feladattal terhelt óraszám" label-placement="stacked" fill="outline" placeholder=""
                type="number"><ion-icon slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Nyugdíjas státusz kezdete" label-placement="stacked" fill="outline" placeholder=""
                type="date" max="3000-12-31"><ion-icon slot="start" name="time"
                  aria-hidden="true"></ion-icon></ion-input><br>
            </ion-col>
            <ion-col>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;">
                      Főállás</ion-checkbox>
                  </div>
                </label>
              </div><br>
              <ion-input label="Szerződésszám" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                  slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

                    <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;">
                      Tartós távollét</ion-checkbox>
                  </div>
                </label>
              </div><br>
            </ion-col>
          </ion-row>





          <ion-row *ngIf="segment=='4'">
            <ion-col>
              <ion-input label="Felhasználónév" label-placement="stacked" fill="outline" placeholder=""
                disabled><ion-icon slot="start" name="person-circle" aria-hidden="true"></ion-icon></ion-input><br>
              <ion-input label="Jelszó" label-placement="stacked" fill="outline" placeholder=""
                type="password"><ion-icon slot="start" name="key" aria-hidden="true"></ion-icon></ion-input>

            </ion-col>
            <ion-col>
              <!---->
              <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Jogkör</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Jogkör</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="lock-open" aria-hidden="true"></ion-icon>
                    <ionic-selectable item-content [items]="orszag" formControlName="orszag" itemValueField="id"
                      itemTextField="nev" [canSearch]="true" [canClear]="true" closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat'" [searchPlaceholder]="'Keresés'" [hasInfiniteScroll]="true"
                      clearButtonText="Visszaállítás">
                    </ionic-selectable>
                  </div>
                </label>
              </div>
              <br>
              <ion-input label="Ismételt jelszó" label-placement="stacked" fill="outline" placeholder=""
                type="password"><ion-icon slot="start" name="key" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='4'">
            <ion-col>
              <ion-button color="primary" expand="block" disabled>
                <ion-icon slot="start" name="open"></ion-icon>
                További KAS adatok szerkesztése
              </ion-button>
              <p>A felhasználó kétfaktoros azonosítását, jelszavát, bejelentkezett eszközeit a KAS felületen tekintheti
                meg a felhasználó. Másik felhasználó adatainak megtekintésére biztonsági okokból nincs lehetőség!</p>
            </ion-col>
          </ion-row>




          <ion-row *ngIf="segment=='5'">
            <ion-col>
              <ion-card color="primary">
                <ion-card-header>
                  <ion-card-title>Végzettségek importálása</ion-card-title>
                  <ion-card-subtitle style="text-align: justify;">Az oktatási mérföldkövek szolgáltatással lehetőség van
                    az adott munkatárs vagy tanuló teljes életútját importálni. Ehhez a felhasználónak rendelkeznie kell
                    a szolgáltatással (merfoldkovek.oh.gov.hu). A Sulinform rendszerébe belépve ezek után lehetősége
                    lesz a felhasználónak importálnia adatait. Ezzel az importált adatok azonnal megbízhatónak lesznek
                    titulálva a forrásuk miatt.</ion-card-subtitle>
                </ion-card-header>

              </ion-card>

              <div style="margin-top: 10px;">
                <ion-button color="primary" id="uzenet">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="allomany"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'created_at', dir: 'desc' },
        { prop: 'updated_at', dir: 'desc' },
        { prop: 'priority', dir: 'desc' },
        { prop: 'deadline', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="Típus">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Típus</b>
                      {{ row.viselt_vez }} {{ row.viselt_ker }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Ország">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Ország</b>

                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Irsz." prop="szul_hely">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Irsz.</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Helység" prop="oktazon">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Helység</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Cím" prop="adid">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Cím</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Alapértelmezett" prop="adid">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Alapértelmezett</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Műveletek">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Műveletek</b>
                      <ion-button color="secondary" size="small" style="margin-top:0">
                        <ion-icon slot="icon-only" name="create"></ion-icon>

                      </ion-button>
                      <ion-button color="danger" size="small" style="margin-top:0">
                        <ion-icon slot="icon-only" name="trash"></ion-icon>

                      </ion-button>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </ng-container>
            </ion-col>
          </ion-row>





          <ion-row *ngIf="segment=='6'">
            <ion-col>
              <ion-card color="primary">
                <ion-card-header>
                  <ion-card-title>Pedagógus-életpályamodell importálása</ion-card-title>
                  <ion-card-subtitle style="text-align: justify;">Az oktatási mérföldkövek szolgáltatással lehetőség van
                    az adott munkatárs vagy tanuló teljes életútját importálni. Ehhez a felhasználónak rendelkeznie kell
                    a szolgáltatással (merfoldkovek.oh.gov.hu). A Sulinform rendszerébe belépve ezek után lehetősége
                    lesz a felhasználónak importálnia adatait. Ezzel az importált adatok azonnal megbízhatónak lesznek
                    titulálva a forrásuk miatt.</ion-card-subtitle>
                </ion-card-header>

              </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="segment=='6'">
            <ion-col>
              <ion-input label="Értesítési telefonszám" label-placement="stacked" fill="outline" placeholder=""
                type="date" max="3000-12-31"><ion-icon slot="start" name="medical"
                  aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
            <ion-col>

            </ion-col>
            <ion-col>

            </ion-col>
          </ion-row>
        </ion-grid>
      </form>

    </ion-content>
  </ng-template>
</ion-modal>